import React from 'react';
import { Col, Row } from "react-bootstrap";

import { HeaderStepper } from './HeaderStepper/HeaderStepper';
import QueryString from 'query-string';
import {CustomerSupportPhone} from '../../Account/ContactUsPhoneEmail';

export default function Ineligible(props) {

  const productName = QueryString.parse(props.location.search).productName || '';

  return (
      <HeaderStepper hideProgressTracker title={productName || 'Ineligible'} className="page-content">
        <Row className="justify-content-center">
          <Col lg={6}>
            <h4 className="consentCardTitle">We’re sorry - you’re not eligible for this product</h4>
            <p className="consentCardText">
              Thank you for your interest in {productName || 'this product'}. Unfortunately, you (or the proposed insured) are not eligible for this product, but don’t worry - this can happen for any number of reasons and doesn’t mean you can’t find other suitable options.
              <br /> <br />
              We can help you find the right insurance coverage at the right price. Based on the information you provided in your previous application, we would love to show you the options you’re most likely eligible for. <a href="/landing/term">Click here</a> to see other products from our partners.
              <br /><br />
            For an even more personalized experience call us at {CustomerSupportPhone()}.
            </p>
          </Col>
        </Row>
      </HeaderStepper>
  )
}




// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Ineligible.js